import { useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { useLocationId } from '@/data/useLocationId';
import { triageApi } from '../api/triageApi';

export function useTriageAssignees() {
  const locationId = useLocationId();
  return useQuery({
    queryKey: keys.triage.assignees(locationId),
    queryFn: ({ signal }) =>
      triageApi.getAssignees(locationId != null ? { location_id: locationId } : undefined, { signal }),
    staleTime: 5 * 60_000,
  });
}
